var _path, _rect, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25928 8.1106H25.0093L23.5319 26.5285C23.4485 27.5677 22.5808 28.3686 21.5383 28.3686H5.73027C4.68771 28.3686 3.82004 27.5677 3.73667 26.5285L2.25928 8.1106Z",
    fill: "#9B97A9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.634277,
    y: 3.43677,
    width: 26,
    height: 4.67491,
    rx: 1,
    fill: "#9B97A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11475 0.368652C8.01018 0.368652 7.11475 1.26408 7.11475 2.36865V3.48526H8.73975V3.48557H18.4897V3.48526H20.1147V2.36865C20.1147 1.26408 19.2193 0.368652 18.1147 0.368652H9.11475ZM18.4897 3.48526V1.92727H8.73975V3.48526H18.4897Z",
    fill: "#9B97A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35391 12.1134C6.32693 11.6478 6.69727 11.2554 7.16369 11.2554V11.2554C7.59345 11.2554 7.94862 11.5906 7.97347 12.0196L8.69199 24.4221C8.71897 24.8877 8.34863 25.2801 7.88221 25.2801V25.2801C7.45245 25.2801 7.09728 24.9449 7.07243 24.5159L6.35391 12.1134Z",
    fill: "#544F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8218 12.0679C12.8218 11.6191 13.1855 11.2554 13.6343 11.2554V11.2554C14.083 11.2554 14.4468 11.6191 14.4468 12.0679V24.4676C14.4468 24.9163 14.083 25.2801 13.6343 25.2801V25.2801C13.1855 25.2801 12.8218 24.9163 12.8218 24.4676V12.0679Z",
    fill: "#544F5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8971 12.1134C20.924 11.6478 20.5537 11.2554 20.0873 11.2554V11.2554C19.6575 11.2554 19.3024 11.5906 19.2775 12.0196L18.559 24.4221C18.532 24.8877 18.9023 25.2801 19.3688 25.2801V25.2801C19.7985 25.2801 20.1537 24.9449 20.1786 24.5159L20.8971 12.1134Z",
    fill: "#544F5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25928 8.07788H25.0093L24.8787 9.70563H2.38623L2.25928 8.07788Z",
    fill: "#544F5B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ad455dd34a4c9ca01d4f825ed0688fe1.svg";
export { ForwardRef as ReactComponent };